import Notification from 'components/Notification';
import NextSteps from 'components/Footer/NextSteps';
import Questions from 'components/Footer/Questions';
import { Img } from 'components/shared';
import * as React from 'react';
export default {
  Notification,
  NextSteps,
  Questions,
  Img,
  React
};